import type { Period } from '@/entities/types';
import { toFullDayDateString } from '@/utils/datetime';
import type { ChatMessage, ChatMessageInput } from './types';

export type SuggestedTask = { messageId: string; blockIndex: number };

export function prepareChatMessage(input: ChatMessageInput): ChatMessage {
  return {
    ...input,
    blocks: input.blocks,
    id: crypto.randomUUID(),
    createdAt: new Date(),
    updatedAt: new Date(),
  };
}

export function generateConversationId(
  userId: string,
  period: Period,
  targetStartAt: Date,
): string {
  const dateKey = toFullDayDateString(targetStartAt);
  return `${userId}-${period}-${dateKey}`;
}

export function getMostRecentSuggestedTask(
  messages: ChatMessage[],
): SuggestedTask | undefined {
  return [...messages]
    .reverse()
    .filter((m) => m.role === 'assistant')
    .flatMap((message) =>
      [...message.blocks]
        .map((block, i) => ({ block, blockIndex: i, messageId: message.id }))
        .reverse()
        .filter(({ block }) => block.type === 'entity' && block.status === 'suggested')
        .map(({ messageId, blockIndex }) => ({ messageId, blockIndex })),
    )
    .at(0);
}
